import { CHANGE_MEMBERSHIP, CHANGE_MEMBERSHIP_SUCCESS, CHANGE_MEMBERSHIP_ERROR, CHANGE_MEMBERSHIP_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ChangeMembership = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_MEMBERSHIP:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CHANGE_MEMBERSHIP_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CHANGE_MEMBERSHIP_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CHANGE_MEMBERSHIP_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ChangeMembership;
